
// ToC: H2/H3 only; exclude ToC header, author cards, and FAQ onward.
// Starts collapsed; smooth-scroll; active highlight; chevron toggle.

document.addEventListener('DOMContentLoaded', () => {
  const card = document.querySelector('.free-bleed-toc-card');
  if (!card) return;

  // Header + toggle
  const header =
    card.querySelector('.free-bleed-toc-header') ||
    (() => {
      const h3 = card.querySelector('h3');
      const wrap = document.createElement('div');
      wrap.className = 'free-bleed-toc-header';
      if (h3) h3.replaceWith(wrap.appendChild(h3));
      card.prepend(wrap);
      return wrap;
    })();

  let nav = card.querySelector('.toc-nav');
  if (!nav) {
    nav = document.createElement('nav');
    nav.className = 'toc-nav';
    nav.id = 'free-bleed-toc-nav';
    nav.setAttribute('aria-label', 'Table of contents');
    card.appendChild(nav);
  }
  nav.innerHTML = '<ul class="free-bleed-toc-list"></ul>';
  const listEl = nav.querySelector('.free-bleed-toc-list');

  let toggleBtn = card.querySelector('.free-bleed-toc-toggle');
  if (!toggleBtn) {
    toggleBtn = document.createElement('button');
    toggleBtn.className = 'free-bleed-toc-toggle';
    toggleBtn.type = 'button';
    toggleBtn.setAttribute('aria-controls', 'free-bleed-toc-nav');
    toggleBtn.innerHTML =
      '<svg class="free-bleed-toc-chevron" viewBox="0 0 24 24" fill="none" stroke="currentColor"><polyline points="6,9 12,15 18,9" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"></polyline></svg>';
    header.appendChild(toggleBtn);
  }

  // Scope to article body
  const content =
    document.querySelector('.article .article__content') ||
    document.querySelector('.article__content') ||
    document;

  // Collect H2/H3, excluding ToC itself, author cards, and explicit opt-outs
  const all = Array.from(content.querySelectorAll('h2, h3')).filter(
    (h) =>
      !h.closest('.free-bleed-toc-card') &&
      !h.closest('.free-bleed-author-card') &&
      !h.matches('[data-toc-exclude], .no-toc')
  );
  if (!all.length) {
  card.remove(); // no headings at all — remove ToC
  return;
}


  // Exclude everything from the first FAQ onward
  const isFaq = (el) => {
    const t = (el.textContent || '').trim().toLowerCase();
    return t.includes('faq') || t.includes('frequently asked questions');
  };
  const cutoff = all.findIndex(isFaq);
  const headings = cutoff >= 0 ? all.slice(0, cutoff) : all;
  if (!headings.length) {
  card.remove(); // all filtered out (e.g. only FAQ onward) — remove ToC
  return;
}


  // Build ToC
  const used = new Set();
  const slugify = (txt) => {
    const base = (txt || 'section')
      .trim().toLowerCase()
      .replace(/[^\w\s-]/g, '')
      .replace(/\s+/g, '-')
      .replace(/-+/g, '-') || 'section';
    let s = base, i = 2;
    while (used.has(s) || document.getElementById(s)) s = `${base}-${i++}`;
    used.add(s);
    return s;
  };

  listEl.innerHTML = '';
  let currentH2 = null;

  headings.forEach((h, idx) => {
    if (!h.id) h.id = slugify(h.textContent || `section-${idx}`);

    const a = document.createElement('a');
    a.className = 'free-bleed-toc-link';
    a.href = `#${h.id}`;
    a.textContent = (h.textContent || '').trim();

    if (h.tagName.toLowerCase() === 'h2') {
      const li = document.createElement('li');
      li.appendChild(a);
      listEl.appendChild(li);
      currentH2 = li;
    } else {
      let parent = currentH2;
      if (!parent) parent = listEl.appendChild(document.createElement('li'));
      let sub = parent.querySelector('.free-bleed-toc-sublist');
      if (!sub) {
        sub = document.createElement('ul');
        sub.className = 'free-bleed-toc-sublist';
        parent.appendChild(sub);
      }
      const li = document.createElement('li');
      li.appendChild(a);
      sub.appendChild(li);
    }
  });

  // Smooth scroll & active highlight
  const OFFSET = 80;
  card.addEventListener('click', (e) => {
    const link = e.target.closest('.free-bleed-toc-link');
    if (!link) return;
    e.preventDefault();
    const id = link.getAttribute('href').slice(1);
    const target = document.getElementById(id);
    if (!target) return;
    const top = target.getBoundingClientRect().top + window.pageYOffset - OFFSET;
    window.scrollTo({ top, behavior: 'smooth' });

    card.querySelectorAll('.free-bleed-toc-link.is-active').forEach(el => el.classList.remove('is-active'));
    link.classList.add('is-active');
  });

  const obs = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        if (!entry.isIntersecting) return;
        const link = card.querySelector(`.free-bleed-toc-link[href="#${entry.target.id}"]`);
        if (!link) return;
        card.querySelectorAll('.free-bleed-toc-link.is-active').forEach(el => el.classList.remove('is-active'));
        link.classList.add('is-active');
      });
    },
    { rootMargin: `-${OFFSET + 10}px 0px -70% 0px`, threshold: 0 }
  );
  headings.forEach(h => obs.observe(h));

  // Collapsible: start CLOSED
  const setCollapsed = (collapsed) => {
    card.classList.toggle('is-collapsed', collapsed);
    toggleBtn.setAttribute('aria-expanded', String(!collapsed));
    toggleBtn.setAttribute('aria-label', collapsed ? 'Expand table of contents' : 'Collapse table of contents');
    // height transition
    nav.style.maxHeight = nav.scrollHeight + 'px';
    requestAnimationFrame(() => {
      nav.style.maxHeight = collapsed ? '0px' : nav.scrollHeight + 'px';
    });
  };

  // Initialize closed without animating on load
  card.classList.add('is-collapsed');
  toggleBtn.setAttribute('aria-expanded', 'false');
  toggleBtn.setAttribute('aria-label', 'Expand table of contents');
  nav.style.maxHeight = '0px';

  // Toggle handlers
  toggleBtn.addEventListener('click', () => {
    setCollapsed(!card.classList.contains('is-collapsed'));
  });
  header.querySelector('h3')?.addEventListener('click', () => {
    setCollapsed(!card.classList.contains('is-collapsed'));
  });

  // Keep height in sync when expanded and window resizes
  window.addEventListener('resize', () => {
    if (!card.classList.contains('is-collapsed')) {
      nav.style.maxHeight = nav.scrollHeight + 'px';
    }
  });
});
